export type Translations = Map<string, string>;

export enum CategoryTypeEnum {
    NORMAL = 'NORMAL',
    ANIMAL = 'ANIMAL',
    BRANDS = 'BRANDS',
    OFFERS = 'OFFERS',
    SPECIAL_OFFERS = 'SPECIAL_OFFERS',
    TRIAL_OFFERS = 'TRIAL_OFFERS',
    NEW_PRODUCTS = 'NEW_PRODUCTS',
    OUTLET = 'OUTLET',
}

export interface UiCategory {
    animalType?: string;
    children?: UiCategory[];
    description: string;
    extId: number;
    level: number;
    path: string;
    pictureFile?: string;
    specials?: UiCategory[];
    title: string;
    type?: CategoryTypeEnum;
    whitespaceAfter?: number;
    highlighted: boolean;
}

export interface UiCategoryExt extends UiCategory {
    active: boolean;
    children?: UiCategoryExt[];
    specials?: UiCategoryExt[];
}

export type Bundle = 'zooplus' | 'bitiba';

export type Cart = {
    summary: {
        articleCount: number;
    };
};
